let numericFormatter = new Intl.NumberFormat('en-UK', {
    style: 'decimal',
    minimumFractionDigits: 0,
});

export const numberWithCommas = (x) => {
    return numericFormatter.format(x);
};

export const handleSmallImages = (smallImage) => {
    let url = smallImage;
    const tag = '_small';
    let position = url.length - 4;
    let output = `${url.substring(0, position)}${tag}${url.substring(
      position,
    )}`;
    return output;
};

export const getAddressFullName = (address) => {
    let fullName = '';

    if (address === null){
        return '';
    }

    if (address.addressIndividual === true) {
        if (address.addressIndividualTitle !== null && address.addressIndividualTitle !== '') {
            fullName = address.addressIndividualTitle + ' ';
        }
        if (address.addressIndividualFirstName !== null && address.addressIndividualFirstName !== '') {
            fullName += address.addressIndividualFirstName + ' ';
        }
        if (address.addressIndividualSurname !== null && address.addressIndividualSurname !== '') {
            fullName += address.addressIndividualSurname + ' ';
        }
        if (address.addressIndividualSuffix !== null && address.addressIndividualSuffix !== '') {
            fullName += address.addressIndividualSuffix;
        }
    } else {
        fullName = address.addressOrganisationName;
    }
    
    return fullName;
};

export const getSysSetting = (id) => {
    let settings = JSON.parse(localStorage.getItem('sys_settings'));
    
    return settings.filter(function(item) { return item.id === id; })[0];
};